import { render, staticRenderFns } from "./ToDoPurchaseYiXinApplication.vue?vue&type=template&id=5fb2b818&scoped=true&"
import script from "./ToDoPurchaseYiXinApplication.vue?vue&type=script&lang=js&"
export * from "./ToDoPurchaseYiXinApplication.vue?vue&type=script&lang=js&"
import style0 from "./ToDoPurchaseYiXinApplication.vue?vue&type=style&index=0&id=5fb2b818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2b818",
  null
  
)

export default component.exports